import { render, staticRenderFns } from "./VulnerableDescription.vue?vue&type=template&id=1a87c70c&"
import script from "./VulnerableDescription.vue?vue&type=script&lang=js&"
export * from "./VulnerableDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports